const env = import.meta.env;

export const API_BASE_URL = (env.VITE_API_BASE_URL ?? "http://127.0.0.1:8000/api").replace(/\/$/, "");
export const BASENAME_APP = env.VITE_BASENAME_APP ?? "/";
export const SPRITE_BASE_URL = env.VITE_SPRITE_BASE_URL ?? "";
export const BASEMAP_GAIA_STYLE_URL =
  env.VITE_BASEMAP_GAIA_STYLE_URL ??
  "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json";
export const BASEMAP_SATELLITE_STYLE_URL =
  env.VITE_BASEMAP_SATELLITE_STYLE_URL ??
  "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json";
